module.exports = __webpack_public_path__ + "static/img/GrahamCornes.66fbc34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GrahamCornes.jpg
// module id = YQNI
// module chunks = 0